import { type ReactNode } from 'react'

import { ButtonDefault } from '@/components/common/Button'

import { type ClipboardBuyButtonType } from '../ClipboardBuyLinksButton'

import { useScgExport } from './useScgExport'

type Props = {
  buttonProps: ClipboardBuyButtonType
  children: ReactNode
  decklist: string[]
  onTrack: (label: string) => void
}

export const ClipboardBuyLinksButtonSCG = ({ buttonProps, children, decklist, onTrack }: Props) => {
  const { loading, onClick } = useScgExport({ decklist, onTrack })

  return (
    <ButtonDefault {...buttonProps} disabled={decklist.length < 1 || loading} loading={loading} onClick={onClick}>
      {children}
    </ButtonDefault>
  )
}
